module.exports = __webpack_public_path__ + "img/v.fa961363.jpg";